import axios from 'axios';
import { getAccessToken } from './session';

const baseUrl = 'https://foodsy-api.faimsoft.com/';

const apiUrl = {
    signIn: `${baseUrl}accounts/sign-in/`,
    deleteAccount: `${baseUrl}accounts/delete-account/`,
    seller: `${baseUrl}foodsy/sellers/`,
    // approvel_deactivate_saller: `${baseUrl}foodsy/approve-seller/`,
    // activate_deactivate_saller: `${baseUrl}foodsy/activate-seller/`,
    store_open: `${baseUrl}foodsy/store-open/`,

    //seller
    shopPhoto: `${baseUrl}seller`,
    Logo: `${baseUrl}seller`,
    sellerLogo: `${baseUrl}foodsy/seller-update/`,
    sellerPhoto: `${baseUrl}foodsy/seller-update/`,
    sellerApprove: `${baseUrl}foodsy/approve-seller/`,
    sellerActivate: `${baseUrl}foodsy/activate-seller/`,
    sellerUpdate: `${baseUrl}foodsy/seller-update/`,
    sallerShopPhoto: `${baseUrl}foodsy/seller-update/`,


    // pincode: `${baseUrl}common/area`,
    // menu

    foodImg: `${baseUrl}menu`,
    foodMenu: `${baseUrl}foodsy/menu/`,
    foodUpdate: `${baseUrl}foodsy/food-item/`,
    foodDetails: `${baseUrl}foodsy/food-item/`,
    foodDelete: `${baseUrl}foodsy/food-item/`,
    variants: `${baseUrl}foodsy/food-variant/`,
    variantsDelete: `${baseUrl}foodsy/food-variant/`,
    foodApprove: `${baseUrl}foodsy/approve-food/`,
    foodActivate: `${baseUrl}foodsy/activate-food/`,
    foodSearch: `${baseUrl}foodsy/find-food/`,


    // common
    category: `${baseUrl}common/category`,
    subcategories: `${baseUrl}common/sub-categories`,
    city: `${baseUrl}common/city`,
    state: `${baseUrl}common/state`,
    area: `${baseUrl}common/area`,
    activeteAccount: `${baseUrl}foodsy/activate/`,


    // store-time
    storeTime: `${baseUrl}foodsy/store-timing/`,
    storeOpen: `${baseUrl}foodsy/store-open/?`,
    storeTimeUpdate: `${baseUrl}foodsy/store-timing/`,

    // user
    userList: `${baseUrl}foodsy/user-list/`,
    userDetails: `${baseUrl}foodsy/user-list/`,
    userSearch: `${baseUrl}foodsy/user-search/`,
    userOrders: `${baseUrl}foodsy/user-orders/`,

    // delivery
    deliveryList: `${baseUrl}foodsy/delivery-list/`,
    deliverySearch: `${baseUrl}foodsy/delivery-search/`,
    deliveryorders: `${baseUrl}foodsy/delivery-orders/`,
    deliveryInfo: `${baseUrl}foodsy/delivery-list/`,
    deliverprofile: `${baseUrl}delivery`,
    // orders
    orderLists: `${baseUrl}foodsy/orders/`,
    orderDetails: `${baseUrl}foodsy/orders/`,
    orderStatusUpdate: `${baseUrl}foodsy/orders/`,

};

export { baseUrl, apiUrl };

export function apiCallUnsecureGet(api, response, error) {
    console.log('apiCallSecureGet ', api);
    axios
        .get(api)
        .then((res) => {
            console.warn('result', res)
            const result = res.data;
            if (result.code === 200) {
                response(result)
            } else {
                error(result.msg)
            }
        })
        .catch((err) => {
            if (err.response) {
                error(err.response.data.msg)
            } else if (err.request) {
                console.log(err.request);
                error(err.request)
            } else {
                console.log('Error', err.message);
                error(`Error ${err.message}`)
            }
            console.log(err.config);
        });

}

export function apiCallSecureGet(api, response, error) {

    console.log('apiCallSecureGet ', api);
    axios
        .get(api,
            {
                headers: {
                    'Authorization': `Token ${getAccessToken()}`
                }
            }
        )
        .then((res) => {
            console.warn('result', res.data)
            const result = res.data;
            if (result.code === 200) {
                response(result)
            } else {
                error(result.msg)
            }
        })
        .catch((err) => {
            if (err.response) {
                error(err.response.data.msg)
            } else if (err.request) {
                console.log(err.request);
                error(err.request)
            } else {
                console.log('Error', err.message);
                error(`Error ${err.message}`)
            }
            console.log(err.config);
        });

}

export function apiCallPostWithForm(api, form, response, error) {

    console.log('uploadFile ', api);

    axios.post(api, form, {
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Token ${getAccessToken()}`
        },
    })
        .then((res) => {
            console.warn('result', res)
            const result = res.data;
            if (result.code === 200) {
                response(result)
            } else {
                error(result.msg)
            }
        })
        .catch((err) => {
            if (err.response) {
                error(err.response.data.msg)
            } else if (err.request) {
                console.log(err.request);
                error(err.request)
            } else {
                console.log('Error', err.message);
                error(`Error ${err.message}`)
            }
            console.log(err.config);
        });
};

export function apiCallPutWithForm(api, form, response, error) {

    console.log('uploadFile ', api);

    axios.put(api, form, {
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Token ${getAccessToken()}`
        },
    })
        .then((res) => {
            console.warn('result', res)
            const result = res.data;
            if (result.code === 200) {
                response(result)
            } else {
                error(result.msg)
            }
        })
        .catch((err) => {
            if (err.response) {
                error(err.response.data.msg)
            } else if (err.request) {
                console.log(err.request);
                error(err.request)
            } else {
                console.log('Error', err.message);
                error(`Error ${err.message}`)
            }
            console.log('Error', err.response);
        });
};

export function uploadFile(api, name, file, response, error) {

    console.log('uploadFile ', api);
    console.log(name, file.name);

    const formData = new FormData();
    formData.append(name, file);
    axios.post(api, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Token ${getAccessToken()}`
        },
    })
        .then((res) => {
            console.warn('result', res)
            const result = res.data;
            if (result.code === 200) {
                response(result)
            } else {
                error(result.msg)
            }
        })
        .catch((err) => {
            if (err.response) {
                error(err.response.data.msg)
            } else if (err.request) {
                console.log(err.request);
                error(err.request)
            } else {
                console.log('Error', err.message);
                error(`Error ${err.message}`)
            }
            console.log(err.config);
        });
};

export function apiCallPostFormData(api, formData, response, error) {

    console.log('apiCallPostFormData ', api);

    axios.post(api, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Token ${getAccessToken()}`
        },
    })
        .then((res) => {
            console.warn('result', res)
            const result = res.data;
            if (result.code === 200) {
                response(result)
            } else {
                error(result.msg)
            }
        })
        .catch((err) => {
            if (err.response) {
                error(err.response.data.msg)
            } else if (err.request) {
                console.log(err.request);
                error(err.request)
            } else {
                console.log('Error', err.message);
                error(`Error ${err.message}`)
            }
            console.log(err.config);
        });
};

export function apiCallSecureDelete(api, id, response, error) {

    const url = `${api}?id=${id}`;
    console.log('apiCallSecureDelete ', url);
    axios
        .delete(url,
            {
                headers: {
                    'Authorization': `Token ${getAccessToken()}`
                }
            }
        )
        .then((res) => {
            console.warn('result', res)
            const result = res.data;
            if (result.code === 200) {
                response(result)
            } else {
                error(result.msg)
            }
        })
        .catch((err) => {
            if (err.response) {
                error(err.response.data.msg)
            } else if (err.request) {
                console.log(err.request);
                error(err.request)
            } else {
                console.log('Error', err.message);
                error(`Error ${err.message}`)
            }
            console.log(err.config);
        });

}

export function apiPostUnsecure(api, data, response, error) {

    console.log('apiPostUnsecure ', api, 'data ', data);

    axios
        .post(api, data)
        .then((res) => {
            console.warn('result', res)

            const result = res.data;

            if (result.code === 200) {
                response(result)
            } else {
                error(result.msg)
            }

        })
        .catch((err) => {
            if (err.response) {
                error(err.response.data.msg)
            } else if (err.request) {
                console.log(err.request);
                error(err.request)
            } else {
                console.log('Error', err.message);
                error(`Error ${err.message}`)
            }
            console.log(err.config);
        });
}


export function apiPostSecure(api, data, response, onError) {

    console.log('apiPostSecure ', api, 'data ', data);

    axios
        .post(
            api,
            data,
            {
                headers: {
                    'Authorization': `Token ${getAccessToken()}`
                }
            }
        )
        .then((res) => {
            console.log('result', res.data)

            const result = res.data;

            if (result.code === 200) {
                response(result)
            } else {
                onError(result.msg)
            }

        })
        .catch((err) => {
            try {

                console.log('error', err.response)

                if (err.response) {
                    onError(err.response.data.msg)
                } else if (err.request) {
                    console.log(err.request);
                    onError(err.request)
                } else {
                    console.log('Error', err.message);
                    onError(`Error ${err.message}`)
                }
            } catch (e) {
                console.log(e);
                onError('Something went wrong!')
            }
            console.log(err.config);
        });
}



export function apiDeleteSecureWithBody(api, data, response, onError) {

    console.log('apiDeleteSecureWithBody ', api, 'data ', data);

    axios
        .delete(
            api,
            {
                headers: {
                    'Authorization': `Token ${getAccessToken()}`
                }
            },
            data
        )
        .then((res) => {
            console.log('result', res.data)

            const result = res.data;

            if (result.code === 200) {
                response(result)
            } else {
                onError(result.msg)
            }

        })
        .catch((err) => {
            try {

                console.log('error', err.response)

                if (err.response) {
                    onError(err.response.data.msg)
                } else if (err.request) {
                    console.log(err.request);
                    onError(err.request)
                } else {
                    console.log('Error', err.message);
                    onError(`Error ${err.message}`)
                }
            } catch (e) {
                console.log(e);
                onError('Something went wrong!')
            }
            console.log(err.config);
        });
}

export function apiPutSecure(api, data, response, error) {

    console.log('apiPutSecure ', api, 'data ', data);

    axios
        .put(
            api,
            data,
            {
                headers: {
                    'Authorization': `Token ${getAccessToken()}`
                }
            }
        )
        .then((res) => {
            console.warn('result', res)

            const result = res.data;

            if (result.code === 200) {
                response(result)
            } else {
                error(result.msg)
            }

        })
        .catch((err) => {
            if (err.response) {
                error(err.response.data.msg)
            } else if (err.request) {
                console.log(err.request);
                error(err.request)
            } else {
                console.log('Error', err.message);
                error(`Error ${err.message}`)
            }
            console.log(err.config);
        });
}

export default apiCallUnsecureGet;

